import { render, staticRenderFns } from "./phonelist.vue?vue&type=template&id=aa2da93a&scoped=true&"
import script from "./phonelist.vue?vue&type=script&lang=js&"
export * from "./phonelist.vue?vue&type=script&lang=js&"
import style0 from "./phonelist.vue?vue&type=style&index=0&id=aa2da93a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2da93a",
  null
  
)

export default component.exports